export const comData = [
  { id: 0, nameList: ["新探健康发展研究中心", "北京健康教育协会"] },
  { id: 1, name: ["云南省人口和卫生健康宣传教育中心", "云南省健康教育协会"] },
  { id: 2, name: ["上海市控制吸烟协会"] },
  { id: 3, name: ["人民日报健康客户端"] },
  { id: 4, name: ["河北省疾病预防控制中心"] },
  {
    id: 5,
    name: ["黑龙江省爱国卫生运动委员会办公室", "黑龙江省疾病预防控制中心"],
  },
  { id: 6, name: ["江苏省健康教育协会"] },
  { id: 7, name: [" 浙江省疾病预防控制中心", "浙江省健康促进与教育协会"] },
  {
    id: 8,
    name: [
      "福建省疾病预防控制中心",
      "福建省医学会科学普及分会",
      "福建省预防医学会科学普及专委会",
    ],
  },
  { id: 9, name: ["江西省爱国卫生与健康宣传促进中心"] },
  { id: 10, name: ["山东省疾病预防控制中心"] },
  { id: 11, name: ["河南省疾病预防控制中心"] },
  { id: 12, name: ["湖北省健康促进与控制吸烟学会"] },
  { id: 13, name: ["重庆市健康教育所"] },
  { id: 14, name: ["四川省疾病预防控制中心", "四川省健康教育协会"] },
  { id: 15, name: ["贵州省疾病预防控制中心"] },
  { id: 16, name: ["陕西省健康教育中心"] },
  { id: 17, name: ["青海省疾控中心健康教育所"] },
  { id: 18, name: ["中国健康促进基金会"] },
  { id: 19, name: ["中华预防医学会"] },
  { id: 20, name: ["中国健康促进与教育协会"] },
  { id: 21, name: ["中国生物多样性保护与绿色发展基金会控烟工作组"] },
  { id: 22, name: ["辽宁省健康教育协会"] },
  { id: 23, name: ["行者论健app"] },
];
